import React from "react";
import { AlertCircle } from "lucide-react";

interface ErrorDisplayProps {
  error: string | null | undefined;
  id?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, id }) => {
  if (!error) return null;

  return (
    <div id={id} className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-center gap-2">
      <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
      <span className="text-sm text-red-700">{error}</span>
    </div>
  );
};

export default ErrorDisplay;

